import {ChangeDetectorRef, Component} from '@angular/core';
import {BaseComponent, FilterModel, Page, PRIVILEGES} from "common-shared";
import {BehaviorSubject} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {ManufacturingItemGroupService} from "../manufacturing-item-group.service";
import {take, takeUntil} from "rxjs/operators";
import {saveAs} from 'file-saver';
import {FilterMetadata} from "primeng/api";
import {ItemGroupListFilter} from "web-shared";

@Component({
  selector: 'app-item-group-list',
  templateUrl: './item-group-list.component.html',
  styles: [
  ]
})
export class ItemGroupListComponent extends BaseComponent {
  filter: FilterModel<ItemGroupListFilter> = new FilterModel<ItemGroupListFilter>({
    Data: new ItemGroupListFilter(),
    Page: new Page()
  });
  defaultFilter: {
    [s: string]: FilterMetadata | FilterMetadata[];
  } = {};
  stateKey: string;
  search$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  protected readonly PRIVILEGES = PRIVILEGES;

  constructor(protected router: Router, public changeDetector: ChangeDetectorRef, private manufacturingItemGroupService: ManufacturingItemGroupService, private activatedRoute: ActivatedRoute) {
    super();
  }

  ngOnInit() {
    FilterModel.ensureCustomFilterApplied(this.activatedRoute.routeConfig?.data['filter'], this.defaultFilter);
    const customStateKey = this.activatedRoute.routeConfig?.data['stateKey'];
    this.stateKey = customStateKey ?? 'item-template-list-state';
  }

  goToAdd(){
    this.router.navigate(['./manufacturing/item-template/add']).catch(reason => console.error(reason));
  }

  saveExcel(includeImeTab: boolean) {
    this.manufacturingItemGroupService.downloadListExcel(this.filter, includeImeTab).pipe(take(1), takeUntil(this.componentDestroyed)).subscribe(value => {
      saveAs(value.data, value.fileName);
    });
  }

  runChangeDetector() {
    this.changeDetector.detectChanges();
  }
}
